import React from "react";
import { useNavigate } from "react-router-dom";
import classes from "./Drawer.module.css";
import { FaRegUser, FaBan, FaRegSnowflake, FaRegRectangleList } from "react-icons/fa6";
import { useDispatch, useSelector } from "react-redux";
import { setDrawer } from "../store/slices/drawerSlice";

const Drawer = ({ active }) => {
    const navigate = useNavigate();
    const { drawer } = useSelector(state => state?.drawerSlice);
    const dispatch = useDispatch();

    const { tokenData } = useSelector(state => state?.tokenSlice);


    const toggleDrawer = () => {
        dispatch(setDrawer(!drawer));
    }

    return (
        <div
            className={`${classes.drawer_overlay} ${drawer && classes.show
                }`}
            onClick={() => toggleDrawer()}
        >
            <div
                className={`${classes.drawer} ${drawer && classes.show
                    }`}
                onClick={(e) => e.stopPropagation()}
            >
                <div className={classes.drawer_sub_container}>
                    <div className={classes.logo_center}>
                        <img
                            src="/assets/images/logo.png"
                            alt="Logo"
                            className={classes.logo}
                        />
                    </div>
                    <div className={classes.drawer_items}>
                        {tokenData?.admin == 'rainboo' &&
                            <button className={`${classes.drawer_item} ${active === 0 && classes.active}`}
                                onClick={() => navigate("/home")}>
                                <FaRegRectangleList className={classes.drawer_icon} />
                                <p className={classes.btn_text}>
                                    MIS
                                </p>

                            </button>
                        }
                        <button className={`${classes.drawer_item} ${active === 1 && classes.active}`}
                            onClick={() => navigate("/user-logs")}>
                            <FaRegUser className={classes.drawer_icon} />
                            <p className={classes.btn_text}>
                                User Logs
                            </p>

                        </button>

                        {
                            tokenData?.admin == 'rainboo' &&
                            <button className={`${classes.drawer_item} ${active === 2 && classes.active}`}
                                onClick={() => navigate("/user-blacklist")}>
                                <FaBan className={classes.drawer_icon} />
                                <p className={classes.btn_text}>
                                    User Blacklist
                                </p>

                            </button>
                        }

                        {
                            tokenData?.admin == 'rainboo' &&
                            <button className={`${classes.drawer_item} ${active === 3 && classes.active}`}
                                onClick={() => navigate("/leaderboard")}>
                                <FaRegSnowflake className={classes.drawer_icon} />
                                <p className={classes.btn_text}>
                                    Leaderboard
                                </p>

                            </button>
                        }

                        <button className={`${classes.drawer_item} ${active === 4 && classes.active}`}
                            onClick={() => navigate("/unsubscription")}

                        >
                            <FaRegSnowflake className={classes.drawer_icon} />
                            <p className={classes.btn_text}>
                                Unsubscription
                            </p>

                        </button>


                    </div>
                </div>
            </div>
        </div>
    );
};

export default Drawer;